<template>
  <div>
    <!-- @edit-actived="mainEditActived"
      show-header-overflow
      @cell-dblclick="noEdit"
      @checkbox-change="checkboxChangeEvent"
      class="affect-item"
      @checkbox-all="checkboxChangeEvent"
      @current-change="getCurrentChange"
      @custom="customEvent" -->
    <vxe-grid
      ref="xGrid"
      v-bind="gridOptions"
      @edit-actived="activeEdit"
      :cell-style="{
        padding: '3px',
        'font-size': '12px',
        'line-height': '16px ',
      }"
    >
      <template #AI_toolbar_buttons>
        <div>
          <div style="display: flex">
            <el-button
              class="btn btn1"
              icon="el-icon-circle-plus-outline"
              @click="addNewData"
              >{{ $t("message.button.add") }}
            </el-button>
            <el-button
              class="btn btn2"
              icon="el-icon-delete"
              @click="removeCheckbox"
              >{{ $t("message.button.delete") }}
            </el-button>

            <div style="margin-left: 10px; margin-right: 15px">
              <el-button
                class="btn btn7"
                icon="el-icon-document-checked"
                @click="getUpdateEvent"
                >{{ $t("message.button.save") }}
              </el-button>
              <el-button
                class="btn btn8"
                icon="el-icon-circle-close"
                @click="closeSave"
                >{{ $t("message.button.cancel") }}
              </el-button>
            </div>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import { gridOptions } from "@/utils/tableConfig.js";
import {
  saveOrUpdateCustomizeFormAPI,
  deleteCustomizeFormAPI,
} from "./tableItemAPI";
import { setSubDataItemVal } from "./config";
import axios from "axios";

export default {
  data() {
    return {
      gridOptions: { ...gridOptions, height: 300 },
      changeData: [],
    };
  },
  props: {
    data: {
      type: Object,
      default: {
        columns: [],
        data: [],
      },
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const { columns, data } = this.data;
      this.gridOptions.columns = [{ type: "checkbox", width: 50 }, ...columns];
      this.gridOptions.data = data;
    },
    addNewData() {
      const { columns } = this.data;
      const obj = {};
      columns.forEach((i) => {
        const { field } = i;
        obj[field] = "";
      });
      console.log(obj);
      this.gridOptions.data.push(obj);
      this.changeData.push(obj);
    },
    delConfirm() {
      return this.$confirm(this.$t("message.confirm.deleteData"));
    },
    removeCheckbox() {
      const xGrid = this.$refs.xGrid;
      const rows = xGrid.getCheckboxRecords();
      const arr = rows.filter((ele) => ele?.rowId).map((i) => i.rowId);
      if (!arr.length) {
        this.handleDelete(rows);
        return;
      }
      this.delConfirm()
        .then((res) => {
          return deleteCustomizeFormAPI({ deleteIds: arr });
        })
        .then((res) => {
          this.handleDelete(rows);
        });
    },
    handleDelete(rows) {
      const xGrid = this.$refs.xGrid;
      //   const idList = xGrid.getData().map((i) => i.id);
      rows.forEach((ele) => {
        const { id } = ele;
        const index = xGrid.getData().findIndex((i) => i.id === id);
        this.gridOptions.data.splice(index, 1);
      });
    },
    setSubData() {
      const { columns } = this.data;
      const arr = this.changeData.map((item) => {
        const obj = {};
        for (const key in item) {
          if (key.indexOf("pre") !== -1) {
            const column = columns.find((i) => i.field === key);
            const keyLabel = key.replace("pre", "");
            // obj[keyLabel] = item[key];
            obj[keyLabel] = setSubDataItemVal(item[key], column);
          }
        }
        item["rowId"] && (obj["id"] = item["rowId"]);
        return obj;
      });
      return arr;
    },

    getUpdateEvent() {
      const { id: frameId } = this.data;
      const { id, classId, subClassId } = this.$route.query;
      const objId = { id, classId, subClassId, version: 0 };
      const customizeForms = this.setSubData();
      const obj = {
        frameId,
        objId,
        customizeForms,
      };
      saveOrUpdateCustomizeFormAPI(obj).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message)
        }
      });
    },
    closeSave() {},
    getListEntry(column) {
      const { property } = column;
      const { columns, data } = this.data;
      const item = columns.find((i) => property === i.field);
      console.log(item, columns, property);

      if (![3, 4].includes(item.uiType)) {
        return;
      }
      const { listValue } = item;
      axios
        .get(`/pmdm/admin/list/getListEntriesSimple?listId=${listValue}`)
        .then((res) => {
          console.log(res);
          column.editRender.options = res.data.object.rawListEntries.map(
            (i) => {
              const { entryValue, listId, entryId } = i;
              return { value: entryValue, label: listId + "_" + entryId };
            }
          );
        });
    },
    activeEdit({ row, column }) {
      const rowIdList = this.changeData.map((i) => i.rowId);
      if (!rowIdList.includes(row.rowId)) {
        this.changeData.push(row);
      }
      this.getListEntry(column);
    },
  },
};
</script>

<style></style>